var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
 if (links[i].hostname !== window.location.hostname) {
  links[i].target = '_blank';
  links[i].rel = 'noreferrer noopener';
 }
}

(function ($) {
  var LOG_PREFIX = '[coaroo-fixed]';

  function log() {
    if (window.COAROO_FIXED_DEBUG === false) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }

  if (!$) {
    console.warn(LOG_PREFIX, 'jQuery が見つかりません。customize.js の読み込み順を確認してください。');
    return;
  }

  var fancyboxAvailable = typeof $.fancybox === 'function';
  if (!fancyboxAvailable) {
    console.warn(LOG_PREFIX, '$.fancybox がありません。購入モーダルは使えません。');
  }

  var fixedBar = document.getElementById('fixed-bottom-actions');
  var backToTop = document.getElementById('back-to-top');
  if (!fixedBar || !backToTop) {
    console.warn(LOG_PREFIX, '固定バー要素がありません（fixed-bottom-actions / back-to-top）');
    return;
  }

  var scrollThreshold = 300;
  var stickyCart = fixedBar.querySelector('.fixed-bottom-actions__cart');
  var isProductPage = document.body.classList.contains('template-product');
  var mainAddToCart = isProductPage
    ? document.querySelector('.product-container .product-purchase-form .add-to-cart[name="add"]')
    : null;
  var stickyPurchaseSuffix = '-sp';
  var cartChangedHandler = null;

  log('init', {
    isProductPage: isProductPage,
    fancyboxAvailable: fancyboxAvailable,
    stickyCart: !!stickyCart,
    mainAddToCart: !!mainAddToCart
  });

  function hideFancyboxActivity() {
    if ($.fancybox && $.fancybox.hideActivity) {
      $.fancybox.hideActivity();
    }
  }

  function updateBarVisibility() {
    if (window.scrollY > scrollThreshold) {
      fixedBar.hidden = false;
      fixedBar.classList.add('is-visible');
    } else {
      fixedBar.classList.remove('is-visible');
      fixedBar.hidden = true;
    }
  }

  function syncStickyCart() {
    if (!stickyCart || !mainAddToCart) return;

    stickyCart.disabled = false;
    stickyCart.textContent = mainAddToCart.textContent;

    stickyCart.className = 'fixed-bottom-actions__cart';
    mainAddToCart.classList.forEach(function (className) {
      stickyCart.classList.add(className);
    });
  }

  function removeCartChangedHandler() {
    if (cartChangedHandler) {
      document.documentElement.removeEventListener('theme:cartchanged', cartChangedHandler);
      cartChangedHandler = null;
    }
  }

  function bindCloseOnCartAdded() {
    removeCartChangedHandler();
    cartChangedHandler = function () {
      if (!$('#fancybox-content .sticky-purchase-modal').length) return;
      window.setTimeout(function () {
        $.fancybox.close();
      }, 300);
      removeCartChangedHandler();
    };
    document.documentElement.addEventListener('theme:cartchanged', cartChangedHandler);
  }

  function refineStickyPurchaseTemplate($template) {
    $template.find('.not-in-quickbuy').remove();
    $template.find('.only-in-quickbuy').remove();
    $template.find('.product-gallery, .gallery-thumbs, .descriptionunder').remove();
    // ProductJson 以外の script は除去（JSON は残す）
    $template.find('script').not('[type="application/json"]').remove();

    var $inner = $template.find('.product-info .inner');
    if ($inner.length) {
      $inner.children().not('h1.product-title, .pricearea, .productoptions').remove();
    }

    $template.find('.pricearea form').remove();
    $template.find('.shopify-payment-button, .store-availability, .backorder').remove();
    $template.find('.with-payment-button').removeClass('with-payment-button');
    $template.find('.add-to-cart.button--alt').removeClass('button--alt');

    $template.find('[data-enable-history-state]').attr('data-enable-history-state', false);

    // 8.0.0 Quick Buy と同様、モーダル内では URL を書き換えない
    $template.find('variant-picker').each(function () {
      this.dataset.updateUrl = 'false';
    });

    $template.find('label[for]').each(function () {
      var forAttr = $(this).attr('for');
      if (forAttr && forAttr.indexOf(stickyPurchaseSuffix) === -1) {
        $(this).attr('for', forAttr + stickyPurchaseSuffix);
      }
    });

    $template.find('form[id], input[id], select[id], textarea[id], button[id]').each(function () {
      var id = this.getAttribute('id');
      if (!id || typeof id !== 'string') return;
      if (id.indexOf('ProductJson-') === 0 || id.indexOf(stickyPurchaseSuffix) !== -1) return;
      this.setAttribute('id', id + stickyPurchaseSuffix);
    });
  }

  function buildStickyPurchaseTemplate() {
    var $sourceForm = $('.product-info.product-form').first();
    var $sourceInner = $sourceForm.find('.inner').first();

    log('build', {
      sourceForm: $sourceForm.length,
      sourceInner: $sourceInner.length,
      title: $('.product-info h1.product-title').length,
      price: $('.product-info .pricearea').length,
      options: $('.product-info .productoptions').length
    });

    if (!$sourceInner.length) {
      console.warn(LOG_PREFIX, '購入エリア .product-info .inner が見つかりません');
      return null;
    }

    var $inner = $sourceInner.clone(true, true);
    $inner.children().not('h1.product-title, .pricearea, .productoptions').remove();

    var $template = $('<div class="quickbuy-form sticky-purchase-modal">').append(
      $('<div class="product-container cf">').append(
        $('<div class="product-info product-form">')
          .addClass($sourceForm.attr('class'))
          .attr({
            'data-ajax-add-to-cart': $sourceForm.attr('data-ajax-add-to-cart'),
            'data-product-id': $sourceForm.attr('data-product-id'),
            'data-enable-history-state': 'false'
          })
          .append($inner)
      )
    );

    var $productJson = $sourceForm.find('script[type="application/json"][id^="ProductJson-"]').first();
    if ($productJson.length) {
      $template.find('.product-form').append($productJson.clone());
    }

    refineStickyPurchaseTemplate($template);

    var formCount = $template.find('.product-purchase-form').length;
    log('build result', { forms: formCount, htmlLength: $template.html().length });

    if (!formCount) {
      console.warn(LOG_PREFIX, 'モーダル用フォーム .product-purchase-form が作れませんでした');
      return null;
    }

    return $template;
  }

  function initStickyPurchaseModal() {
    try {
      var $modal = $('#fancybox-content .sticky-purchase-modal.quickbuy-form');
      log('onComplete', { modal: $modal.length });

      if (!$modal.length) return;

      // 6系互換: OptionManager がある場合のみ従来初期化
      // 8.0.0 では product-form / variant-picker カスタム要素が担うため不要
      if (window.theme && theme.OptionManager) {
        theme.OptionManager.initProductOptions($modal.find('.product-form'));
        if (theme.loadClickyboxOptions) theme.loadClickyboxOptions($modal);
        if (theme.applyAjaxToProductForm) theme.applyAjaxToProductForm($modal);
      }

      bindCloseOnCartAdded();
      $modal.find('.close-box:first').focus();
    } catch (err) {
      console.error(LOG_PREFIX, 'モーダル初期化エラー', err);
    }
  }

  function cleanupStickyPurchaseModal() {
    // Fancybox は onCleanup が例外を投げると閉じ処理が止まり、以降 close 不能になる
    try {
      var $modal = $('.sticky-purchase-modal.quickbuy-form');
      if ($modal.length && window.theme && theme.OptionManager) {
        theme.OptionManager.unloadProductOptions($modal.find('.product-form'));
        if (theme.unloadClickyboxOptions) theme.unloadClickyboxOptions($modal);
        if (theme.removeAjaxFromProductForm) theme.removeAjaxFromProductForm($modal);
      }
    } catch (err) {
      console.error(LOG_PREFIX, 'モーダルクリーンアップエラー', err);
    }
    removeCartChangedHandler();
  }

  function openStickyPurchaseModal() {
    log('open modal click');

    if (!isProductPage) {
      console.warn(LOG_PREFIX, '商品ページではありません（body に template-product がありません）');
      return;
    }

    if (!fancyboxAvailable) {
      console.warn(LOG_PREFIX, 'Fancybox がないため購入エリアへスクロールします');
      var target = document.querySelector('.product-info .productoptions');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var $template = buildStickyPurchaseTemplate();
    if (!$template || !$template.html().trim()) {
      console.warn(LOG_PREFIX, 'モーダル用 HTML が空のため中止しました');
      hideFancyboxActivity();
      return;
    }

    var closeLabel = window.theme && theme.strings ? theme.strings.close : 'Close';
    var closeIcon = window.theme && theme.icons ? theme.icons.close : '×';
    var $actionIcons = $(
      '<div class="action-icons">' +
        '<a href="#" class="close-box action-icon" aria-label="' + closeLabel + '">' +
        closeIcon +
        '</a></div>'
    );

    log('fancybox open');

    // 公式 Quick Buy と同様、DOM ノードを直接渡す（HTML 文字列化するとカスタム要素が壊れやすい）
    $template.prepend($actionIcons);
    $.fancybox({
      padding: 0,
      showCloseButton: false,
      content: $template,
      onComplete: initStickyPurchaseModal,
      onCleanup: cleanupStickyPurchaseModal
    });
  }

  if (stickyCart && isProductPage) {
    stickyCart.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openStickyPurchaseModal();
    });
    log('sticky cart click handler attached');
  } else {
    log('sticky cart handler NOT attached', { stickyCart: !!stickyCart, isProductPage: isProductPage });
  }

  if (stickyCart && mainAddToCart) {
    var observer = new MutationObserver(syncStickyCart);
    observer.observe(mainAddToCart, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });
    syncStickyCart();
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('.product-purchase-form [name="id"]')) {
        window.setTimeout(syncStickyCart, 0);
      }
    });
  }

  window.addEventListener('scroll', updateBarVisibility, { passive: true });
  updateBarVisibility();

  backToTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})(window.jQuery);

// 「レビューでキャッシュバック」→ Judge.me の「レビューをチェック」と同じスクロールにする
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.review-cashback-btn');
    if (!btn) return;

    event.preventDefault();

    var badge =
      document.querySelector('.jdgm-preview-badge .jdgm-prev-badge__text') ||
      document.querySelector('.jdgm-preview-badge .jdgm-prev-badge') ||
      document.querySelector('.jdgm-widget.jdgm-preview-badge');

    if (badge) {
      badge.click();
      return;
    }

    var target =
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('.jdgm-rev-widg');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
